const pressRegistry = new WeakSet();

function bindPressPage(page) {
  if (pressRegistry.has(page)) {
    return;
  }

  const panels = [...page.querySelectorAll("[data-press-panel]")];
  const triggers = [...page.querySelectorAll("[data-press-trigger]")];

  if (!panels.length || !triggers.length) {
    return;
  }

  let activePanel = panels.find((panel) => panel.classList.contains("is-active"))?.dataset.pressPanel || panels[0].dataset.pressPanel;

  const updateUI = (nextPanel) => {
    activePanel = nextPanel;

    panels.forEach((panel) => {
      const isActive = panel.dataset.pressPanel === activePanel;
      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    triggers.forEach((trigger) => {
      trigger.classList.toggle("is-active", trigger.dataset.pressTrigger === activePanel);
    });
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      updateUI(trigger.dataset.pressTrigger);
    });
  });

  updateUI(activePanel);
  pressRegistry.add(page);
}

export default function initPressDev(root = document) {
  root.querySelectorAll("[data-press-dev]").forEach(bindPressPage);
}
